import React from "react";
import { Grid2 as Grid, useTheme } from "@mui/material";
import { DollarSign, BarChart2, TrendingUp, Calendar } from "lucide-react";
import MiniStatCard from "../../../ui/cards/MiniStatCard";
import { WorkOpportunity } from "../../../../store/services/opportunityService";
import { calculateStatistics } from "./helpers";

const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat("sv-SE", {
    style: "currency",
    currency: "SEK",
    maximumFractionDigits: 0,
  }).format(amount);
};

const StatisticsCards: React.FC<{
  stats: ReturnType<typeof calculateStatistics>;
  filteredAndSortedOpportunities: WorkOpportunity[];
}> = ({ stats, filteredAndSortedOpportunities }) => {
  const theme = useTheme();
  return (
    <Grid container spacing={3} sx={{ mb: 3 }}>
      <Grid size={{ xs: 12, sm: 6, md: 3 }} >
        <MiniStatCard
          title="Totalt värde"
          value={formatCurrency(stats.totalValue)}
          icon={<DollarSign />}
          color={theme.palette.success.main}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }} >
        <MiniStatCard
          title="Genomsnittlig sannolikhet"
          value={`${Math.round(stats.averageProbability)}%`}
          icon={<BarChart2 />}
          color={theme.palette.primary.main}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }} >
        <MiniStatCard
          title="Högsta värde"
          value={
            stats.highestValueOpportunity
              ? formatCurrency(
                  stats.highestValueOpportunity.OpportunityTotalAmount || 0
                )
              : "0 kr"
          }
          icon={<TrendingUp />}
          color={theme.palette.info.main}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }} >
        <MiniStatCard
          title="Nästa slutdatum"
          value={
            filteredAndSortedOpportunities.length > 0
              ? new Date(
                  filteredAndSortedOpportunities[0].OpportunityCloseDate ||
                    new Date()
                ).toLocaleDateString("sv-SE")
              : "Inget datum"
          }
          icon={<Calendar />}
          color={theme.palette.warning.main}
        />
      </Grid>
    </Grid>
  );
};

export default StatisticsCards;
